import { translate } from "@atoms/atom-client/i18n";
import { Container, Root, Text } from "@react-three/uikit";
import { Button } from "../components/default/button";

export const MissingPartDisplay = () => {
  return (
    <Root>
      <Container
        flexGrow={1}
        backgroundOpacity={0.5}
        hover={{ backgroundOpacity: 1 }}
        backgroundColor="red"
      >
        <Button>
          <Text>
            {translate("app.emerge.missingPart", "Fehlendes Bauteil")}
          </Text>
        </Button>
      </Container>
    </Root>
  );
};
